export const ResponsiveOverlay = {
  Link: {
    extends: 'SquareButton',
    theme: 'quaternary',
    color: 'title',
    icon: 'logov2',
    href: 'https://symbols.app',
    'aria-label': (el) => el.call('polyglot', 'shell.overlay.brandHome')
  },
  IconText: {
    icon: 'deviceTabletLandscapeHalf fill',
    lineHeight: '1.4',
    gap: 'Z',
    text: '{{ editor.overlay.smallView | polyglot }}',
    '@mobileM': {
      flow: 'column',
      textAlign: 'center'
    }
  },
  // The one action — the kit's ink primary (the kit owns the scale: it was
  // the brand Button with a hand-set padding, Rule 68).
  Button: {
    extends: 'AppCapsuleBtnPrimary',
    // Playwright smoke harness binds via this exact string —
    // qa-automation/pages/signin.page.ts (and homepage.page.ts) openAnyway.
    'data-testid': 'ResponsiveOverlay.Button',
    text: '{{ editor.overlay.openAnyway | polyglot }}',
    onClick: (ev, el) => el.parent.remove()
  },
  flow: 'column',
  if: (el) => {
    const isTesting = location.host.includes('localhost')
    const isCanvas = location.pathname.includes('srcdoc')
    const isEmbed = el.isEmbed()
    if (isEmbed || isCanvas || isTesting) return false
    return true
  },
  display: 'none',
  align: 'center space-between',
  position: 'fixed',
  inset: '0 0 0 0',
  boxSize: '100%',
  padding: 'C',
  zIndex: '999999',
  gap: 'A',
  '@tabletL': {
    display: 'flex'
  },
  // The page ground and its ink, in both schemes (DESIGN_SPEC S16: tokens) —
  // it was a raw `black.9` / `gray15.95` pair under a 3px blur. The notice
  // covers the whole screen, so the ground is opaque and needs no blur.
  theme: 'document'
}
